export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match. Please try again.',
  signInSuccess: 'Signed in successfully. Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Signed out sucessfully!',
  signOutFailure: 'Failed to sign out. Please try again.',
  changePasswordSuccess: 'Password changed successfully.',
  changePasswordFailure: 'Failed to change password. Please make sure your password and password confirmation match and try again.',
  memoryCreateSuccess: 'Your memory has been saved.',
  memoryCreateFailure: 'Failed to save your memory. Please try again.',
  memoryUpdateSuccess: 'Your memory has been updated!',
  memoryUpdateFailure: 'Failed to update your memory. Please try again.',
  memoryDestroySuccess: 'Your memory has been deleted.',
  memoryDestroyFailure: 'Failed to delete your memory. Please try again.',
  memoryIndexSuccess: 'All memories retrieved successfully.',
  memoryIndexFailure: 'Failed to display your memories. Please try again.',
  memoryShowSuccess: 'Your memory is now displayed.',
  memoryShowFailure: 'Failed to open your memory. Please try again.',
  memoryDeleteSuccess: 'Your memory has been deleted.',
  memoryDeleteFailure: 'Failed to delete your memory. Please try again.'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js